import { guid } from "../../../Helpers";
import {
  appendParams,
  convertToTimeDropDownValue,
  useFetchData,
  useParseRouteActions,
} from "../../../helpers/GlobalHelper";
import { GlobalConstants, LmsTimeDropdownOptions } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import LmsTabPages from "../ui/LmsTabPages";

const LmsInspectionsCompanyInspectionsMainTable = () => {
  const actionButtons = [
    "add", 
    "edit", 
    "remove",
    "export", 
    "save",
    "cancel"
  ];

  return <LmsTable 
    actionButtons={actionButtons} 
    apiSuffix="inspections/company-inspections"
    useApiFiltering
    deleteSuffix="inspections/company-inspections"
    saveSuffix="inspections/company-inspections"
    myForm={editInspectionCompanyInspectionsFormFields(new BCFormController())}
    columnLabelsDictionary={{
      dateInspected: "Inspected On", 
      loanNumber: "Loan #"
    }}
    columnClickOptions={{
      loanDraw: { path: "inspections-inspection-company-inspections", idProp: "id", },
      documentFileName: { downloadPath: "inspections/company-inspections/{id}/download", idProp: "id" }
    }}
  />;
};

const addInspectionCompanyInspectionsFormFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Draw", "inspections/list-loan-draws", {
      name: "loanDrawId",
      required: true
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Work Inspection Company Organization", "inspections/list-inspection-companies", {
      name: "workInspectionCompanyOrganizationId",
      required: true
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Message No", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Inspection No", { required: true }),
  ]);

  myForm.addCenteredGroup([myForm.getCalendarField("Inspected On")]);
  myForm.addCenteredGroup([myForm.getCalendarField("Submitted On")]);
  return myForm;
};

const inspectionCompanyInspectionsDetailFormFields = ( myForm ) => {
  myForm.addCenteredGroup([
    myForm.getDisplayField("Inspection Company Inspection", { name: "nwccinspectionDisplay" }),
    myForm.getBlankField(),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Budget Detail", "inspections/list-nwccinspection-loan-budget-details", {
      name: "loanBudgetDetailId",
      required: true,
      dependencyField: "nwccinspectionId"
    }),
    myForm.getInputField("Line Number", { required: true, inlineEdit: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Percent Complete"),
    myForm.getInputField("Cumulative Percent Complete"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Budget Group No"),
    myForm.getInputField("Budget Group"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Description", { field: "textarea" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Comments", { name: "comment", field: "textarea" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Error Message", { field: "textarea" }),
  ]);

  return myForm;
};

const inspectionCompanyInspectionsDocumentFormFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDisplayField("Inspection Company Inspection", { name: "nwccinspectionDisplay" }),
    myForm.getDropdownField("Document Log", "document/list-document-logs", { name: "documentLogId" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Received On"),
    myForm.getDropdownField("Received On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.receivedOn) })
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Date Added"),
    myForm.getDropdownField("Date Added Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.dateAdded) })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Project No"),
    myForm.getInputField("File No"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Caption"),
    myForm.getBlankField(),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("File Type No"),
    myForm.getInputField("File Type"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Inspector No"),
    myForm.getInputField("File Source"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Error Message"),
  ]);

  myForm.addCenteredGroup([myForm.getFileField("Document", { value: true })]);
  return myForm;
};

const LmsInspectionCompanyInspectionsDetailTable = ({ inspectionId, inspectionDetailId = "", suffix = "" }) => {
  const editPath = appendParams("inspections-inspection-company-inspections/editdetail/{id}", [{ inspectionId }, { inspectionDetailId }]);
  const actionButtons = [
    { text: "Add", icon: GlobalConstants.Icons.ADD, path: `/inspections-inspection-company-inspections/adddetail?inspectionId=${inspectionId}` },
    { text: "Edit", icon: GlobalConstants.Icons.EDIT, path: editPath, isDisabled: (checkedItems) => checkedItems?.length !== 1 },
    "remove",
    "export",
    "save",
    "cancel"
  ];

  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix={suffix ? suffix : `inspections/company-inspections/${inspectionId}/details`}
      deleteSuffix="inspections/company-inspection-details"
      onClickPath={editPath}
      columnLabelsDictionary={{ loanBudgetSubCategory: "Sub Category", loanNumber: "Loan #", comments: "Comment" }}
      saveSuffix="inspections/company-inspections/details"
      myForm={inspectionCompanyInspectionsDetailFormFields(new BCFormController())}
    />
  );
};

const LmsInspectionCompanyInspectionsDocumentTable = ({ inspectionId, suffix="" }) => {
  const actionButtons = [
    { text: "Add", icon: GlobalConstants.Icons.ADD, path: `/inspections-inspection-company-inspections/adddocument?inspectionId=${inspectionId}` },
    "remove",
    "export",
  ];

  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix={suffix ? suffix : `inspections/company-inspections/${inspectionId}/doc-logs`}
      deleteSuffix="inspections/company-inspection-documents"
      columnLabelsDictionary={{ loanNumber: "Loan #" }}
      columnClickOptions={{ hasAttachment: { path: "inspections-inspection-company-inspection-documents/view", idProp: "id" }}}
    />
  );
};

const LmsReportsTabPages = ({ id }) => {
  const tabPages = {
    "Details": <LmsInspectionCompanyInspectionsDetailTable inspectionId={id} suffix={`inspections/company-inspections/${id}/details`} />,
    "Document Log": (
      <LmsInspectionCompanyInspectionsDocumentTable inspectionId={id} suffix={`inspections/company-inspections/${id}/doc-logs`} />
    ),
  };

  return <LmsTabPages tabPages={tabPages} />;
};

const editInspectionCompanyInspectionsFormFields = ( myForm ) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Draw", "inspections/list-loan-draws", {
      name: "loanDrawId",
      required: true
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Work Inspection Company Organization", "inspections/list-inspection-companies", {
      name: "workInspectionCompanyOrganizationId",
      required: true,
    }),

    myForm.getInputField("Inspection Status"),
  ]);

  myForm.addCenteredGroup([myForm.getFileField("Document", { 
    value: true, 
    documentFileName: "documentFileName",
    fileFieldName: "documentFileName",
    documentDownloadSuffix:  "inspections/company-inspections/{id}/download",
    name: "attachment" 
  })]);

  myForm.addCenteredGroup([
    myForm.getInputField("Message No"),
    myForm.getInputField("Inspection No"),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Inspected On", { name: "dateInspected" }),
    myForm.getCalendarField("Date Returned"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Percent Complete"),
    myForm.getInputField("Cumulative Percent Complete"),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Submitted On"),
    myForm.getCalendarField("Completed On"),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Files Last Checked On", { required: true }),
    myForm.getCalendarField("Sent To Egnyte On"),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Note"),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Error Message", { inlineEdit: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Description"),
  ]);

  return myForm;
};

export const EditInspectionCompanyInspectionsForm = ({ id, handleClose = undefined as any }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`inspections/company-inspections/${id}`);
  const myForm = editInspectionCompanyInspectionsFormFields(
    new BCFormController(data, { 
      submitSuffix: "inspections/company-inspections",
      submitMethod: "PUT", 
      clearSuffixesOnSubmit: [`inspections/company-inspections/${id}`],
      payloadDataType: "FormData",
      deleteSuffix: "inspections/company-inspections",
      blankWidth: 3 
    }
  ));

  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
      handleClose={handleClose}
    />
  );
};

const EditInspectionCompanyInspectionsDetailForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`inspections/company-inspection-detail/${id}`);
  const myForm = inspectionCompanyInspectionsDetailFormFields(
    new BCFormController(data, { 
      values: { nwccinspectionId: data?.nwccinspectionId },
      submitSuffix: "inspections/company-inspections/details", 
      submitMethod: "PUT", 
      dataFormatterFunc: (data) => { return {...data }; },
      deleteSuffix: "inspections/company-inspection-details",
      clearSuffixesOnSubmit: [`inspections/company-inspection-detail/${id}`, `inspections/company-inspections/${id}/details`],
      blankWidth: 4
    })
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      actions={formActions}
      isLoading={isLoading}
      error={error}
    />
  );
};

export const AddInspectionCompanyInspectionsForm = ({ handleClose = undefined as any }) => {
  const successMessageFormatterFunc = (response, useFormInstance) => {
    const handleConfirmSubmit = () => {
      handleClose ? handleClose() : useFormInstance?.history?.push("/inspections-inspection-company-inspections");
    };

    useFormInstance?.handleConfirmFunc(handleConfirmSubmit, response.data, true);
  };

  const myForm = addInspectionCompanyInspectionsFormFields(
    new BCFormController({}, { 
      submitSuffix: "inspections/company-inspections", 
      submitMethod: "POST", 
      blankWidth: 4,
      successMessageFormatterFunc: successMessageFormatterFunc
    })
  );

  const formActions = [
    { action: "save", text: "Submit" },
    "close",
  ];

  return <LmsFormGenerator myForm={myForm} actions={formActions} handleClose={handleClose}/>;
};

const AddInspectionCompanyInspectionsDetailForm = ({ inspectionId }) => {
  const [{ data, isLoading, error }] = useFetchData(inspectionId ? `inspections/company-inspections/${inspectionId}/details/initial-data` : "");
  const myForm = inspectionCompanyInspectionsDetailFormFields(
    new BCFormController({ ...data, loanBudgetDetailId: "" }, { 
      values: { nwccinspectionId: data?.nwccinspectionId },
      submitSuffix: "inspections/company-inspection-detail", 
      submitMethod: "POST", 
      dataFormatterFunc: (data) => { return {...data, id: guid(), nwccinspectionId: inspectionId }; },
      blankWidth: 4
    })
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />;
};

const AddInspectionCompanyInspectionsDocumentForm = ({ inspectionId }) => {
  const [{ data, isLoading, error }] = useFetchData(`inspections/company-inspections/${inspectionId}/doc-logs/initial-data`);
  const myForm = inspectionCompanyInspectionsDocumentFormFields(
    new BCFormController(data, { 
      submitSuffix: "inspections/company-inspection-documents", 
      submitMethod: "POST", 
      payloadDataType: "FormData",
      dataFormatterFunc: (data) => { return {...data, id: guid(), nwccinspectionId: inspectionId }; },
      blankWidth: 2 
    })
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />;
};

const EditInspectionCompanyInspectionsDocumentForm = ({ id }) => {
  const [{ data, isLoading, error }] = useFetchData(id ? `inspections/company-inspection-documents/${id}` : "");
  const myForm = inspectionCompanyInspectionsDocumentFormFields(
    new BCFormController(data, { 
      submitSuffix: "inspections/company-inspection-documents", // TODO: unsure endpoint, check 14925
      submitMethod: "PUT", 
      dataFormatterFunc: (inputData) => { return { ...inputData, nwccinspectionId: data?.nwccinspectionId }; },
      clearSuffixesOnSubmit: [`inspections/company-inspection-documents/${id}`],
      payloadDataType: "FormData",
      deleteSuffix: "inspections/company-inspection-documents",
      blankWidth: 2 
    })
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />;
};

const LmsInspectionsInspectionCompanyInspections = ({
  params = {},
  history,
}) => {
  const allowedActions = ["add", "edit"];
  const companyInspectionsSubpages = ["adddetail", "editdetail", "adddocument", "editdocument"];
  const allowedSubpages = [...companyInspectionsSubpages] as any[];
  const {
    isAdd,
    isEdit,
    isMainPage,
    isActionAllowed,
    id,
    isSubpageAllowed,
    actionLower,
    query
  } = useParseRouteActions(params, allowedActions, allowedSubpages);
  const inspectionId = query.get("inspectionId") || "";
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <LmsInspectionsCompanyInspectionsMainTable />}
      {isAdd && <AddInspectionCompanyInspectionsForm />}
      {isEdit && (
        <>
          <EditInspectionCompanyInspectionsForm id={id} />
          <LmsReportsTabPages id={id} />
        </>
      )}
      {isSubpageAllowed && (
        <>
          {actionLower === "adddetail" && (
            <AddInspectionCompanyInspectionsDetailForm inspectionId={inspectionId} />
          )}
          {actionLower === "editdetail" && (
            <EditInspectionCompanyInspectionsDetailForm id={id} />
          )}
          {actionLower === "adddocument" && (
            <AddInspectionCompanyInspectionsDocumentForm inspectionId={inspectionId} />
          )}
          {actionLower === "editdocument" && (
            <EditInspectionCompanyInspectionsDocumentForm id={id} />
          )}
        </>
      )}{" "}
    </>
  );
};

export default LmsInspectionsInspectionCompanyInspections;
